import { SaleUnitCartDto } from './saleUnitCart.dto';
import { SaleUnitCartSplitDto } from './saleUnitCartSplit.dto';

export class TableSplitRequestDto {
  saleUnitCart: SaleUnitCartDto;
  saleUnitCartSplit?: SaleUnitCartSplitDto;
}
